import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'

import { Observable, of } from 'rxjs'

import { PermissionValue, RoleDefinition } from '@flowx/designer/modules/workspaces/shared/roles'

import { ApiHttpService } from './api-http.service'

@Injectable()
export class OrganisationAdminRolesApiService extends ApiHttpService {
  configBaseUrl = 'auth/api/organizations/default/roles'

  constructor() {
    const apiUrl = inject<string>('BASE_URL' as any)
    const http = inject(HttpClient)

    super(apiUrl, http)
  }

  getRoles(): Observable<RoleDefinition[]> {
    return this.get(`${this.configBaseUrl}`)
  }

  getRolesByAssetType(): Observable<RoleDefinition[]> {
    return of([])
  }

  createRole(role: RoleDefinition): Observable<RoleDefinition> {
    return this.post(`${this.configBaseUrl}`, role)
  }

  updateRoleBasicInfo(role: RoleDefinition): Observable<RoleDefinition> {
    return this.patch(`${this.configBaseUrl}/${role.id}`, role)
  }

  getRoleById(roleId: RoleDefinition['id']): Observable<RoleDefinition> {
    return this.get(`${this.configBaseUrl}/${roleId}`)
  }

  getRolePermissions(roleId: RoleDefinition['id']): Observable<PermissionValue[]> {
    return this.get(`${this.configBaseUrl}/${roleId}/permissions`)
  }

  updateRolePermissions(
    roleId: RoleDefinition['id'],
    body: { permissions: PermissionValue[] }
  ): Observable<void> {
    return this.patch(`${this.configBaseUrl}/${roleId}/permissions`, body)
  }
}
